<style scoped lang="scss">
.speech-bubble-wrapper {
  max-width: 100%;
  margin: 10px 17px;
}

.linebreak {
  white-space: pre-wrap;
}
.speech-bubble {
  float: left;
  position: relative;
  background: $chat-other-bubble-color;
  border-radius: 4px;
  padding: 10px 20px;
  max-width: 100%;
  word-wrap: break-word;

  &__time {
    color: $gray-800;
  }

  &--with-arrow::after {
    content: "";
    position: absolute;
    left: -16px;
    top: 20px;
    width: 0;
    height: 0;
    border: 16px solid transparent;
    border-right-color: $chat-other-bubble-color;
    border-left: 0;
    border-top: 0;
  }

  &--generic {
    background: $gray-200 !important;
    width: 100%;
    margin: 0;

    a {
      color: lighten($primary, 10);
    }
  }
}

.message--my {
  > .d-flex {
    flex-direction: row-reverse;
  }

  .speech-bubble {
    float: right;
    background: $chat-me-bubble-color;

    &__time {
      text-align: right;
    }

    &--with-arrow::after {
      border: 16px solid transparent;
      border-left-color: $chat-me-bubble-color;
      border-right: 0;
      border-top: 0;
      left: inherit;
      right: -16px;
    }
  }
}

.message--generic {
  padding: 0;
}

.speech-bubble--image {
  img {
    display: block;
    margin: auto;

    height: auto;
    max-height: 100%;

    width: auto;
    max-width: 100%;
  }
}

@media (min-width: 480px) {
  .speech-bubble-wrapper {
    max-width: calc(100% - 129px);
    margin: 10px 21px;
  }
}

@media (min-width: 1100px) {
  .speech-bubble--image {
    max-width: 50%;
  }
}

.pointer {
  cursor: pointer;
}

.editMessage {
  max-width: 100%;
  min-width: 200px;
}
</style>

<template>
  <div
    class="col-12 message"
    :class="{ 'message--my': myMessage, 'message--generic': thirdPartyMessage }"
  >
    <div class="d-flex">
      <div class="flex-grow-1 speech-bubble-wrapper">
        <div
          @mouseover="hover = true"
          @mouseleave="hover = false"
          class="speech-bubble"
          :class="{
            'speech-bubble--with-arrow': speechBubbleArrow,
            'speech-bubble--generic': thirdPartyMessage,
            'speech-bubble--image': imageMessage
          }"
        >
          <component
            v-show="!edit"
            :is="component(message)"
            :message="message"
            :moderation="moderation"
            :profile="profile"
            :class="{ linebreak: withLinebreak(message.type) }"
          />
          <input
            :style="'width:' + width + 'px;'"
            v-show="edit"
            class="form-control editMessage"
            type="text"
            v-model="messageBody"
          />
          <div class="speech-bubble__time">
            <span
              v-if="
                isAuthAdmin &&
                  hover &&
                  isFromFake &&
                  component(message) == 'Message'
              "
            >
              <i
                v-show="!edit"
                @click="editMessage"
                class="fas fa-pen pointer"
              ></i>
              <span class="pointer" @click="saveEditMessage" v-show="edit"
                >save</span
              >
              <span class="pointer" @click="cancelEditMessage" v-show="edit"
                >cancel</span
              >
            </span>
            <i
              v-if="isAuthAdmin && hover"
              class="fas fa-trash-alt pointer"
              @click="showModal"
            ></i>
            <span v-if="moderator && isFromFake" class="text-sm">
              <router-link
                v-if="isAuthAdmin"
                :to="`/moderator/detail/${moderator.user_id}`"
              >
                {{ moderator.user.name }}
              </router-link>
              <span v-else-if="isAuthModerator">{{ moderator.user.name }}</span>
              -
            </span>
            <span
              class="text-sm"
              v-else-if="(isAuthModerator || isAuthAdmin) && isFromFake"
            >
              {{ messageType }}
            </span>
            <span class="text-xs">{{ createdTime }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Message from "@/components/Customer/messages/Message.vue";
import FriendshipRequestMessage from "@/components/Customer/messages/FriendshipRequestMessage.vue";
import GifMessage from "@/components/Customer/messages/GifMessage.vue";
import GiftMessage from "@/components/Customer/messages/GiftMessage.vue";
import SmileMessage from "@/components/Customer/messages/BlinkMessage.vue";
import ImageMessage from "@/components/Customer/messages/ImageMessage.vue";
import SupportMessage from "@/components/Customer/messages/SupportMessage.vue";
import moment from "moment";

export default {
  data() {
    return {
      hover: false,
      edit: false,
      messageBody: ""
    };
  },
  components: {
    Message,
    FriendshipRequestMessage,
    GifMessage,
    GiftMessage,
    SmileMessage,
    ImageMessage,
    SupportMessage
  },
  props: {
    message: {
      required: true,
      type: Object
    },
    profile: {
      required: true,
      type: Object
    },
    moderation: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  created() {
    this.messageBody = this.message.body;
  },
  computed: {
    width() {
      if (this.edit) return 8 * this.messageBody.length;
    },
    myMessage() {
      return this.message.sender_id === this.profile.id;
    },
    imageUrl() {
      if (!this.message.sender) {
        return "/assets/images/default_male.png";
      }

      return this.myMessage
        ? this.profile.primary_image.url
        : this.message.sender.primary_image.url;
    },
    speechBubbleArrow() {
      return (
        [null].includes(this.message.type) || this.message.type === undefined
      );
    },
    thirdPartyMessage() {
      return ["FriendshipRequestMessage"].includes(this.message.type);
    },
    imageMessage() {
      return ["ImageMessage"].includes(this.message.type);
    },
    isFromFake() {
      return this.message.sender_with_trashed
        ? this.message.sender_with_trashed.is_fake
        : this.message.sender.is_fake;
    },
    isAuthAdmin() {
      return this.$store.getters["user/meHasRole"]("admin");
    },
    isAuthModerator() {
      return this.$store.getters["user/meHasRole"]("moderator");
    },
    moderator() {
      return this.message.moderator;
    },
    createdTime() {
      return moment(this.message.created_at).format("HH:mm");
    },
    messageType() {
      if (this.message.circular_mail_id) {
        return `Rundmail: ${this.message.circular_mail_id}`;
      }
      if (this.message.automatic_message_id) {
        return `Automatische Nachricht: ${this.message.automatic_message_id}`;
      }
      if (this.message.admin) {
        return `${this.message.admin.name}`;
      }
      return "";
    }
  },
  methods: {
    showModal() {
      this.$bus.$emit("show-modal", {
        message_id: this.message.id,
        isFromFake: this.isFromFake,
        moderator: this.moderator ? this.moderator.user.name : "",
        price: this.message.price
      });
    },
    editMessage() {
      this.edit = true;
    },
    cancelEditMessage() {
      this.messageBody = this.message.body;
      this.edit = false;
    },
    saveEditMessage() {
      if (this.messageBody) {
        this.$store
          .dispatch("message/update", {
            url: "/api/v1/message/update/" + this.message.id,
            data: { body: this.messageBody }
          })
          .then(() => {
            this.$notify({
              title: "Die Nachricht wurde gespeichert.",
              type: "success"
            });
            this.messageBody = this.message.body;
            this.edit = false;
          });
      } else {
        this.$notify({
          title: "Bitte geben Sie eine Nachricht ein.",
          type: "error"
        });
      }
    },
    component(message) {
      return message.type === null || message.type === undefined
        ? "Message"
        : message.type;
    },
    withLinebreak(message_type) {
      return message_type == "SupportMessage" || message_type == null;
    }
  }
};
</script>
